module.exports = __webpack_public_path__ + "static/media/011_Alternate1.4019efe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/011_Alternate1.png
// module id = 379
// module chunks = 0